import PropTypes from 'prop-types';

var SvgContextMixin = {

  propTypes: {
    box: PropTypes.array.isRequired
  },

  statics: {},

  contextTypes: {
    /** svg container width (in units)*/
    width: PropTypes.number,
    /** svg container height (in units)*/
    height: PropTypes.number,
    /** font family */
    font: PropTypes.string,
    /** get relative length (in units) */
    relative: PropTypes.func,
    /** get relative X coordinate/length (in units)*/
    relativeX: PropTypes.func,
    /** get relative Y coordinate/length (in units)*/
    relativeY: PropTypes.func,
    /** define SVG element (will be render in <defs /> section)*/
    _define: PropTypes.func,
    /** remove SVG element from <defs /> section*/
    _undefine: PropTypes.func,
    /** get link to the defined element [ url(#MyDefinedElement) ]*/
    linkTo: PropTypes.func,
    /** calculate font size for browser */
    getFontSize: PropTypes.func
  },

  getDefaultProps(){
    return {
      box: [0, 0, 0, 0]
    };
  }

};


module.exports = SvgContextMixin;
